import { FaBuilding } from "react-icons/fa";
import { CompaniesViewMain } from "../Components/CompaniesViewMain";
import { CompanyDetailViewMain } from "../Components/CompanyDetailViewMain";
import { VaultGroupDetailViewMain } from "../Components/VaultGroupDetailViewMain";

export const CompaniesModule = (DATA_USER_AUTH = null) => {

    return [
        {
            views: "PRIVATE", path: "/companies", component: <CompaniesViewMain />,
            roles: null, permissions: null, label: "Compañías", icon: <FaBuilding />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: true,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/companies/:id/vault/:groupId", component: <VaultGroupDetailViewMain />,
            roles: null, permissions: null, label: "Grupo de la bóveda", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/companies/:id/:tab", component: <CompanyDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de compañía", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/companies/:id", component: <CompanyDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de compañía", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },

    ]
};
